import React from 'react';
import { FaCheck, FaCircle } from 'react-icons/fa';

const ProgressIndicator = ({ currentStep, steps }) => {
    const getStepStatus = (stepId) => {
        const stepIndex = steps.findIndex(step => step.id === stepId);
        const currentIndex = steps.findIndex(step => step.id === currentStep);

        if (stepIndex < currentIndex) return 'completed';
        if (stepIndex === currentIndex) return 'active';
        return 'pending';
    };

    return (
        <div className="w-full">
            <div className="flex items-center justify-between">
                {steps.map((step, index) => {
                    const status = getStepStatus(step.id);
                    const isLast = index === steps.length - 1;

                    return (
                        <React.Fragment key={step.id}>
                            {/* Step Circle */}
                            <div className="flex flex-col items-center">
                                <div className={`
                  w-10 h-10 rounded-full flex items-center justify-center border-2 transition-all duration-300
                  ${status === 'completed'
                                        ? 'bg-green-500 border-green-500 text-white'
                                        : status === 'active'
                                            ? 'bg-blue-500 border-blue-500 text-white'
                                            : 'bg-gray-100 border-gray-300 text-gray-400'
                                    }
                `}>
                                    {status === 'completed' ? (
                                        <FaCheck className="text-sm" />
                                    ) : (
                                        <FaCircle className="text-sm" />
                                    )}
                                </div>
                                <span className={`
                  text-xs font-medium mt-2 text-center
                  ${status === 'completed'
                                        ? 'text-green-600'
                                        : status === 'active'
                                            ? 'text-blue-600'
                                            : 'text-gray-400'
                                    }
                `}>
                                    {step.title}
                                </span>
                            </div>

                            {/* Connector Line */}
                            {!isLast && (
                                <div className={`
                  flex-1 h-0.5 mx-4 transition-all duration-300
                  ${status === 'completed' ? 'bg-green-500' : 'bg-gray-200'}
                `} />
                            )}
                        </React.Fragment>
                    );
                })}
            </div>

            {/* Progress Bar */}
            <div className="mt-4">
                <div className="w-full bg-gray-200 rounded-full h-2">
                    <div
                        className="bg-gradient-to-r from-blue-500 to-green-500 h-2 rounded-full transition-all duration-500 ease-out"
                        style={{
                            width: `${((steps.findIndex(step => step.id === currentStep) + 1) / steps.length) * 100}%`
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default ProgressIndicator; 